import { createFileRoute } from "@tanstack/react-router";

import { WorkspaceSettingsPage } from "@/features/workspaces/workspace-settings.page";

export const Route = createFileRoute("/_authenticated/workspaces/$slug/settings" as any)({
  component: WorkspaceSettingsPage,
});

export const WorkspaceSettingsRoute = Route;
